import { render, staticRenderFns } from "./UserGuideWelcome.vue?vue&type=template&id=a350e050&"
import script from "./UserGuideWelcome.vue?vue&type=script&lang=ts&"
export * from "./UserGuideWelcome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports